import { DevelopusTreeTableItemCellType } from '../DevelopusTreeTableCell'
import DevelopusTableCellUI from './DevelopusTreeTableCellUIModel'

class DevelopusTreeTableCellsUIModel {
  constructor(cells: DevelopusTableCellUI[]) {
    this.cells = cells
  }

  private readonly cells: DevelopusTableCellUI[]

  toUI(): DevelopusTreeTableItemCellType[] {
    return this.cells.map((cell) => cell.toUI())
  }
}

export default DevelopusTreeTableCellsUIModel
